/**
 * 이전 stage 의 출력 HTML 과 현재 stage 의 출력 HTML 을 side-by-side 로 비교.
 * Monaco 의 DiffEditor 사용. 상단에 어느 쪽이 이전/현재인지 라벨 바 표시.
 */

import { DiffEditor } from '@monaco-editor/react'

interface Props {
  before: string
  after: string
  beforeLabel: string
  afterLabel: string
}

export function StageDiffView({ before, after, beforeLabel, afterLabel }: Props) {
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          borderBottom: '1px solid #e5e5e5',
          background: '#1e1e1e',
          color: '#d4d4d4',
          fontSize: 12,
          fontFamily: 'monospace',
        }}
      >
        <div style={{ padding: '6px 16px', borderRight: '1px solid #333', display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ padding: '1px 6px', background: '#5a1d1d', color: '#ff8888', borderRadius: 3, fontSize: 10, fontWeight: 600 }}>이전</span>
          <span style={{ opacity: 0.85 }}>{beforeLabel}</span>
          <span style={{ marginLeft: 'auto', opacity: 0.5, fontSize: 11 }}>{before.length.toLocaleString()}자</span>
        </div>
        <div style={{ padding: '6px 16px', display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ padding: '1px 6px', background: '#1d3a1d', color: '#88ff88', borderRadius: 3, fontSize: 10, fontWeight: 600 }}>현재</span>
          <span style={{ opacity: 0.85 }}>{afterLabel}</span>
          <span style={{ marginLeft: 'auto', opacity: 0.5, fontSize: 11 }}>{after.length.toLocaleString()}자</span>
        </div>
      </div>
      <div style={{ flex: 1, minHeight: 0 }}>
        <DiffEditor
          height="100%"
          language="html"
          original={before}
          modified={after}
          theme="vs-dark"
          options={{
            minimap: { enabled: false },
            fontSize: 13,
            readOnly: true,
            renderSideBySide: true,
            wordWrap: 'on',
          }}
        />
      </div>
    </div>
  )
}
